module.exports = __webpack_public_path__ + "static/media/record.576bd2d0.png";